<template>
  <v-container fluid class="container">
    <div class="isLoading" v-if="isLoading" @click="isLoading=false">
      <div id="isLoading_text">Please wait, the system is preparing the report.......</div>
    </div>
    <div v-if="!isExpired">
      <div v-if="this.$route.params.username">
        <strong class="black--text text--lighten-1">Customer: {{$route.params.customer_name}} | Username: {{$route.params.username}} | Instance: {{$route.params.user_inst}}</strong>
      </div>
      <v-layout justify-start column fill-height ma-1 mx-2>
        <v-tabs slot="extension" v-model="tabIndex" color="#1D2126" dark>
          <v-tabs-slider color="blue" />
          <v-tab
            v-for="item in user_index"
            :key="item"
            @click.native="getField(user_index[tabIndex],false)"
          >{{ item }}</v-tab>
        </v-tabs>
      </v-layout>
      <v-flex mt-4>
        <top-search-bar @setTime="setTime" @setRefreshTime="setRefreshTime" :setsearch="setDatePickerFromAlert" :clearField="clearField" />
      </v-flex>
      <v-tabs-items v-model="tabIndex">
        <v-layout row wrap mt-5>
          <v-flex lg9 md9 sm9 xs9  style="position:relative; left: 25px;">
            <v-text-field
              v-model="textTemp"
              clearable
              style="color: black;"
              solo
              :placeholder="keySearchEg"
              v-on:click="clickSearch"
              @click:clear="callItBack()"
              @keyup.enter="textSearch"
            >
              <!-- v-slot:prepend-inner -->
              <template v-slot:append-outer>
                <v-btn
                  depressed
                  tile
                  class="save-box"
                  style="background-color: #1D2126; color: #ffffff; outline: none;"
                  v-on:click="clickSaveQuery"
                  @click.stop="
                    editSavedSearchMode = 'Save'
                    showDialogSaveQuery = true
                  "
                  >
                  Save this query
                </v-btn>
                <v-btn
                  depressed
                  tile
                  class="category-box"
                  style="background-color: #1D2126; color: #ffffff; outline: none;"
                  @click.stop="showDialogSavedQuery = true"
                >
                  Category
                </v-btn>
              </template>
            </v-text-field>
          </v-flex>
          <v-flex lg3 md3 style="max-width: 20em; position: relative; right: 0" ml-5>
            <v-btn slot="activator" flat icon dark @click.native="reloadchart = !reloadchart" style="outline: none;">
              <v-tooltip bottom>
                <v-icon slot="activator">replay</v-icon>
                <span>Refresh graph</span>
              </v-tooltip>
              <v-flex class="beta">new</v-flex>
            </v-btn>
            <v-btn slot="activator" flat icon dark @click.native="clearfilter(), clickClearfilter()" style="outline: none;">
              <v-tooltip bottom>
                <v-icon slot="activator">clear_all</v-icon>
                <span>Clear Filter</span>
              </v-tooltip>
            </v-btn>
            <v-btn
              v-if="role !== 'AIS_Dashboard'"
              slot="activator"
              style="outline: none;"
              flat
              icon
              dark
              @click="setQuey()"
            >
              <v-tooltip bottom>
                <v-icon slot="activator" color="red">add_alert</v-icon>
                <span>Set As Alert</span>
              </v-tooltip>
            </v-btn>
            <v-btn
                v-if="role !== 'AIS_Dashboard'"
                slot="activator"
                style="outline: none; position: relative; left: -5px;"
                flat
                icon
                dark
                @click="toSettingWhitelist()"
              >
              <v-tooltip bottom>
                  <v-icon slot="activator">manage_accounts</v-icon>
                  <span>Setting whitelist</span>
                </v-tooltip>
            </v-btn>
            <!--<v-btn-->
            <!--slot="activator" flat-->
            <!--icon dark-->
            <!--:disabled="statusButton"-->
            <!--@click="$refs.exportDashboard.exportDashboard()">-->
            <!--<v-tooltip bottom>-->
            <!--<v-icon slot="activator">picture_as_pdf</v-icon>-->
            <!--<span>Export this dashboard to PDF</span>-->
            <!--</v-tooltip>-->
            <!--<v-flex class="beta">BETA</v-flex>-->
            <!--</v-btn>-->
            <v-btn slot="activator" flat icon dark style="outline: none; position: relative; left: -10px;" @click="$refs.exportDashboard.exportDashboard(),clickExportDashboard()">
              <v-tooltip bottom>
                <v-icon slot="activator">picture_as_pdf</v-icon>
                <span>Export this dashboard to PDF</span>
              </v-tooltip>
              <!-- <v-flex class="beta">BETA</v-flex> -->
            </v-btn>
            <export-dashboard
              ref="exportDashboard"
              :refChart="$refs"
              :slices="slices"
              :selectedIndex="selectedIndex"
            />
            <v-dialog v-model="setAlert" persistent max-width="550px" min-height="1050px">
              <loading :active.sync="addAlertLoading" :can-cancel="false" />
              <v-form ref="formAddAlert" v-model="validAddAlert">
                <v-card dark>
                  <v-toolbar flat>
                    <v-toolbar-title>Create Alert</v-toolbar-title>
                    <v-spacer />
                    <v-btn icon style="outline: none;" @click.native="setAlert=false,clickCloseSetalert()">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-text-field
                      v-model="newAlertName"
                      :rules="nameRules"
                      label="Alert Name"
                      required
                    />
                    <v-layout>
                      <v-combobox
                        v-model="querytext"
                        :rules="queryRule"
                        label="Query by (e.g. facebook)"
                        chips
                        clearable
                        multiple
                      >
                        <template slot="selection" slot-scope="data">
                          <v-chip :selected="data.selected" close @input="remove(data.item)">
                            <strong>{{ data.item }}</strong>&nbsp;
                          </v-chip>
                        </template>
                      </v-combobox>
                    </v-layout>
                    <!-- <v-text-field
                      v-model="selectedIndex"
                      :rules="[v => !!v || 'Selected Index is required']"
                      label="Device"
                    /> -->
                    <v-select
                      v-model="selectedIndex"
                      label="Device"
                      :items="deviceItem"
                      :rules="[v => !!v || 'Device is required']"
                    />
                    <v-select
                      v-model="eventTrigger"
                      :items="eventType"
                      :rules="[v => !!v || 'Event Type is required']"
                      label="Event Type"
                    />
                    <v-flex v-if="eventTrigger === 'count'" lg12 md12 xs12 sm12 d-flex>
                      <v-autocomplete
                        v-if="eventTrigger"
                        v-model="targetField"
                        :items="alertField"
                        :rules="[v => !!v || 'Select Field is required']"
                        label="Select Field To Use Alert"
                      />
                    </v-flex>
                    <v-flex v-if="eventTrigger === 'count'" lg12 md12 xs12 sm12 d-flex>
                      <v-flex lg12 md12 xs12 sm12 d-flex>
                        <v-select
                          v-model="alertTrigger"
                          :items="alertType"
                          :rules="[v => !!v || 'Trigger Alert When is required']"
                          label="Trigger Alert When"
                        />
                        <v-text-field
                          v-model="number"
                          :rules="rulesnumber"
                          label="Number of Results"
                          type="Number"
                          required
                        />
                      </v-flex>
                    </v-flex>
                    <v-flex
                      v-else-if="eventTrigger === 'upload' || eventTrigger === 'download'"
                      lg12
                      md12
                      xs12
                      sm12
                      d-flex
                    >
                      <v-autocomplete
                        v-model="fieldalet"
                        :items="alertField"
                        :rules="[v => !!v || 'Select Field When is required']"
                        label="Select Field To Use Alert BW"
                      />
                    </v-flex>

                    <v-flex v-if="fieldalet" lg12 md12 xs12 sm12 d-flex>
                      <v-flex lg5 md5>
                        <v-select
                          v-model="alertTrigger"
                          :items="alertType"
                          :rules="[v => !!v || 'Trigger Alert When is required']"
                          label="Trigger Alert When"
                        />
                      </v-flex>
                      <v-text-field
                        v-model="number"
                        :rules="rulesnumber"
                        :counter="7"
                        label="Number of Results"
                        type="Number"
                        required
                      />
                      <v-flex lg2 md2>
                        <v-select
                          v-model="unit"
                          :items="units"
                          :rules="[v => !!v || 'Unit is required']"
                          label="Unit"
                        />
                      </v-flex>
                    </v-flex>

                    <v-flex xs16 sm13 d-flex>
                      <v-select
                        v-model="alertInterval"
                        :items="IntervalTime"
                        :rules="[v => !!v || 'Unit is required']"
                        label="Unit"
                      />
                      <v-select
                        v-model="intervals"
                        :items="intervalalert"
                        :rules="rulestime"
                        label="Run Every"
                      />
                    </v-flex>
                    <v-flex xs16 sm13 d-flex>
                      <VueCtkDateTimePicker
                        v-if="alertInterval==='d'"
                        v-model="yourValue"
                        :minute-interval="1"
                        formatted="HH:mm"
                        format="HH:mm"
                        time-format="HH:mm"
                        label="Choose time"
                        disable-date
                      />
                    </v-flex>
                    <v-select
                      v-model="Action"
                      :items="ActionType"
                      :rules="[v => !!v || 'Action is required']"
                      label="Action"
                      required
                    />
                    <v-text-field
                      v-model="email"
                      :rules="[v => !!v || 'Email is required',
                               v => /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},?)+$/.test(v) || 'E-mail must be valid']"
                      label="Sent to (Email)"
                      required
                    />
                  </v-card-text>
                  <v-card-actions>
                    <v-btn light class="grey lighten-2 font-weight-regular" style="outline: none; text-transform: none; font-size: 16px; border-radius: 4px;" @click="setAlerts('test')">Test Alert</v-btn>
                    <v-spacer />
                    <v-btn slot="activator" style="outline: none;  text-transform: none; font-size: 16px; border-radius: 4px;" color="blue darken-3 font-weight-light" @click="setAlerts('create')">
                      Create alert
                    </v-btn>
                    <!-- <v-btn slot="activator" flat icon  @click.native="setAlert=false">
                      <v-icon>cancel</v-icon>
                    </v-btn>-->
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>
          </v-flex>
          <v-flex v-if="role !=='AIS_Dashboard'" :class="class_css" md-5 mt-4>
            <v-btn v-if="editMode" slot="activator" flat small icon dark style="outline: none;">
              <v-tooltip left>
                <v-icon
                  slot="activator"
                  @click="backToDefaultgetTemplate()"
                >restore_page</v-icon>
                <span>Select Template</span>
              </v-tooltip>
            </v-btn>
            <!--<v-dialog-->
            <!--v-if="editMode"-->
            <!--v-model="savetemplateMode"-->
            <!--persistent-->
            <!--:disabled="statusButton"-->
            <!--max-width="500px">-->
            <!--<v-btn-->
            <!--slot="activator"-->
            <!--:disabled="statusButton"-->
            <!--flat-->
            <!--small-->
            <!--icon-->
            <!--dark>-->
            <!--<v-tooltip left>-->
            <!--<v-icon-->
            <!--slot="activator"-->
            <!--@mouseover="backToDefaultmode=false">save</v-icon>-->
            <!--<span>Save Dashboard</span>-->
            <!--</v-tooltip>-->
            <!--</v-btn>-->
            <v-btn v-if="editMode" slot="activator" flat small icon dark style="outline: none;">
              <v-tooltip left>
                <!-- <v-icon slot="activator" @mouseover="backToDefaultgetTemplate()" @mouseleave="backToDefaultmode=false">restore_page</v-icon> -->
                <v-icon
                  slot="activator"
                  @click="conBackToDefault = true"
                >autorenew</v-icon>
                <span>Back to Default</span>
              </v-tooltip>
            </v-btn>
            <!-- <v-btn v-if="editMode" slot="activator" flat small icon dark style="outline: none;">
                <v-tooltip left>
                  <v-icon slot="activator" @mouseover="backToDefaultmode=false" @click="savetemplateMode = true,clickSaveDashboard()">save</v-icon>
                  <span>Save Dashboard</span>
                </v-tooltip>
              </v-btn> -->
            <v-dialog v-model="savetemplateMode" persistent max-width="500px">
              <v-flex v-if="stagNewTemplate === true">
                <v-card dark style="border-radius: 5px;">
                  <!-- <v-toolbar flat>
                    <v-toolbar-title>Confirm Save Template</v-toolbar-title>
                    <v-spacer />
                  </v-toolbar>
                  <v-card-text /> -->
                  <v-card-title
                    class="headline grey darken-4 text-light"
                    primary-title
                  >
                    Confirm Save Template
                  </v-card-title>
                  <v-card-text class="text-md-left grey darken-4">
                      <p>You have made changes. Do you want to discard or save them?</p>
                  </v-card-text>
                  <v-card-actions class="grey darken-4">
                    <v-spacer />
                    <v-btn v-if="!savetemplatePopup" color="red darken-1" flat @click="discard()" style="outline: none; text-transform: none;">
                     Discard
                    </v-btn>
                    <v-btn
                      v-if="!savetemplatePopup"
                      color="green darken-1"
                      style="outline: none;  text-transform: none;"
                      @click.native="saveDashboard"
                    >Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex v-else>
                <v-card v-if="!savetemplatePopup" dark  style="border-radius: 5px;">
                  <!-- <v-toolbar flat>
                    <v-toolbar-title>Confirm Save Template</v-toolbar-title>
                    <v-spacer />
                  </v-toolbar>
                  <v-card-text /> -->
                  <v-card-title
                    class="headline grey darken-4 text-light"
                    primary-title
                  >
                    Confirm Save Template
                  </v-card-title>
                  <v-card-text class="text-md-left grey darken-4">
                      <p>Would you like to save your change?</p>
                  </v-card-text>
                  <v-card-actions class="grey darken-4">
                    <v-spacer />
                    <v-btn
                        v-if="!savetemplatePopup"
                        color="grey darken-1"
                        style="outline: none; text-transform: none;"
                        outline
                        @click.native="savetemplateMode=false"
                      >
                        Back
                      </v-btn>
                      <v-btn
                        v-if="!savetemplatePopup"
                        color="green darken-1"
                        style="outline: none; text-transform: none;"
                        @click.native="saveDashboard"
                      >
                        Save
                      </v-btn>
                  </v-card-actions>
                </v-card>
                <v-card v-if="savetemplatePopup" dark style="border-radius: 5px;">
                  <!-- <v-toolbar flat>
                    <v-toolbar-title>{{ responeSave }}</v-toolbar-title>
                    <v-spacer />
                  </v-toolbar> -->
                  <v-card-title
                    class="headline grey darken-4 text-light"
                    primary-title
                  >
                    {{ responeSave }}
                  </v-card-title>
                  <v-card-actions class="grey darken-4">
                    <v-spacer />
                    <v-btn
                      v-if="savetemplatePopup"
                      color="darken"
                      outline
                      style="outline: none; text-transform: none;"
                      @click.native="
                        savetemplatePopup = !savetemplatePopup
                        savetemplateMode = !savetemplateMode
                        editMode = !editMode
                      "
                      >Close</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-dialog>
            <v-dialog v-model="shownDialogDiscardChanges" persistent max-width="500px">
              <v-card dark style="border-radius: 5px;">
                    <v-card-title
                      class="headline grey darken-4 text-light"
                      primary-title
                    >
                      <span style="margin-left: 15px;">Discard Changes</span>
                    </v-card-title>
                    <v-card-text class="text-md-left grey darken-4">
                        <p style="margin-left: 15px;">You have made changes. Do you yo discard or save them ?</p>
                    </v-card-text>
                    <v-card-actions class="grey darken-4">
                      <v-spacer />
                      <v-btn
                        color="red"
                        style="outline: none; text-transform: none;"
                        outline
                        @click.native="discard"
                      >
                        Discard
                      </v-btn>
                      <v-btn
                        color="green darken-1"
                        style="outline: none; text-transform: none;"
                        @click.native="saveDashboard(),
                        savetemplatePopup = !savetemplatePopup
                        savetemplateMode = !savetemplateMode
                        editMode = !editMode
                        "
                      >
                        Save
                      </v-btn>
                  </v-card-actions>
              </v-card>
            </v-dialog>
            <v-btn v-if="editMode" slot="activator" flat small icon dark style="outline: none;">
              <v-tooltip left>
                <v-icon
                  slot="activator"
                  @mouseover="backToDefaultmode = false"
                  @click="showDialogAddChart = true,clickAddChart()"
                  >add_circle</v-icon
                >
                <span>Add Chart</span>
              </v-tooltip>
            </v-btn>
            <v-dialog
              v-model="showDialogAddChart"
              persistent
              max-width="1200px"
            >
              <v-card dark>
                <v-toolbar flat>
                  <v-toolbar-title>Add Chart</v-toolbar-title>
                  <v-spacer />
                  <v-btn icon style="outline: none;" @click="showDialogAddChart = false,clickCloseAddChart()">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text>
                  <v-flex class="DialogEditAddChart" max-width="1100px">
                    <v-layout row>
                      <v-flex ml-3 lg5 md5>
                        <DashboardDialogAddChart
                          :max-y="slices.length ? findMaxY() : 0"
                          :index="selectedIndex"
                          :index_list="user_index"
                          :chart-type-options="chartType"
                          :chart-field-options="dashField"
                          :chart-field-byte-options="fieldByte"
                          :field-response="fieldResponse"
                          :sum-field-options="eventType"
                          :show_all_field="show_all_field"
                          @preview="previewAddChart"
                          @commit="commitAddChart"
                          @setRefreshIndex="getField"
                          @close="showDialogAddChart = false"
                        />
                      </v-flex>
                      <v-flex mr-1 lg7 md7>
                        <grid-layout
                          :layout.sync="preview_slices_add"
                          :row-height="300"
                          :responsive="true"
                          :cols="{ lg:12, md:12, sm:12, xs:1, xxs:1 }"
                          :is-resizable="editMode"
                          class="position"
                        >
                          <grid-item
                            v-for="item in preview_slices_add"
                            :key="item.slice_id"
                            :x="item.x"
                            :y="item.y"
                            :w="item.w"
                            :h="item.h"
                            :i="item.i"
                            class="chart-item-preview"
                          >
                            <component
                              :preview_slices_add="preview_slices_add"
                              :is="item.chartType"
                              :start-time="startTime"
                              :end-time="endTime"
                              :interval="interval"
                              :interval-time-bar="item.intervalTimeBar"
                              :field="item.field"
                              :chart-id="item.i"
                              :slice="item"
                              :fieldsum="item.fieldsum"
                              :options="item.options"
                              :field-custom="item.fieldCustom"
                              :options-custom="item.optionsCustom"
                              :fields="item.fields"
                              :orderby="item.orderby"
                              :chart-name="item.chartName"
                              :bar_line="item.bar_line"
                              :top-limit="parseInt(item.topLimit)"
                              :group="item.group"
                              :func="item.func"
                              :stores="stores"
                              :sub-filter="item.subFilter"
                              :text="text"
                              :field_st="item.field_st"
                              :field_nd="item.field_nd"
                              :user_inst="user_inst"
                              :lic="lic"
                              :username="username"
                              :user_index="item.index"
                              :index_now="selectedIndex"
                              class="chart-item-preview"
                            />
                          </grid-item>
                        </grid-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-dialog>
            <!-- Create new Template on Admin-->
            <v-btn v-if="editMode && role ==='management'" slot="activator" flat small icon dark style="outline: none;">
              <v-tooltip left>
                <v-icon
                  slot="activator"
                  @click="FuncAddTemplate()"
                  @mouseover="backToDefaultmode=false"
                >note_add</v-icon>
                <span>Create New Template</span>
              </v-tooltip>
            </v-btn>
            <v-dialog
              v-if="editMode"
              v-model="createNewTemplate"
              max-width="600px"
              min-height="500px"
            >
              <DashboardDialogCreateNewTemplate
                :index_list="user_index"
                :user_inst="user_inst"
                @commits="commitAddTemplate"
                @close="createNewTemplate = false"
              />
            </v-dialog>
            <!-- END -->
            <v-btn
              v-if="!editMode"
              slot="activator"
              style="outline: none;"
              flat
              icon
              dark
              @click.native="editMode = !editMode,clickEditMode()"
            >
              <v-tooltip left>
                <v-icon slot="activator">build</v-icon>
                <span>Edit Mode</span>
              </v-tooltip>
            </v-btn>
            <v-btn v-if="editMode" slot="activator" flat small icon dark style="outline: none;">
              <v-tooltip left>
                <v-icon slot="activator" @mouseover="backToDefaultmode=false" @click="savetemplateMode = true,clickSaveDashboard()">save</v-icon>
                <span>Save Dashboard</span>
              </v-tooltip>
            </v-btn>
            <v-btn
              v-if="editMode"
              slot="activator"
              style="outline: none;"
              flat
              icon
              dark
              @click.native="editMode = !editMode,clickCloseEditMode()"
            >
              <v-tooltip left>
                <v-icon slot="activator" @mouseover="backToDefaultmode = false"
                  >close</v-icon
                >
                <span>Exit from Edit Mode</span>
              </v-tooltip>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout mb-2 style="margin:0 10px;">
          <v-select
            v-if="selectTimenew.length > 0"
            v-model="selectTimenew"
            :items="selectTimenew"
            label="Filter"
            chips
            solo
            multiple
            hide-selected
            hide-details
            readonly
            dark
            background-color="#1D2126"
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                :selected="data.selected"
                color="#4478B7"
                close
                text-color="#ccc"
                @input="removeFilterTime(data.item)"
              >
                <strong>{{ data.item }}</strong>
              </v-chip>
            </template>
          </v-select>
        </v-layout>
        <v-layout style="margin:0 10px;">
          <v-select
            v-if="stores.length > 0"
            v-model="selectedStores"
            :items="selectedStores"
            label="Filter"
            chips
            solo
            multiple
            hide-selected
            hide-details
            readonly
            dark
            background-color="#1D2126"
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                :selected="data.selected"
                color="#4478B7"
                close
                text-color="#ccc"
                @input="removeFilter(data.item)"
              >
                <strong>{{ data.item }}</strong>
              </v-chip>
            </template>
          </v-select>
        </v-layout>
        <!-- confrim chart -->
        <v-dialog v-model="conBackToDefault" persistent max-width="500px">
          <v-card dark style="border-radius: 5px;">
                    <v-card-title
                      class="headline grey darken-4 text-light"
                      primary-title
                    >
                      <span style="margin-left: 15px;">Changes template</span>
                    </v-card-title>
                    <v-card-text class="text-md-left grey darken-4">
                        <p style="margin-left: 15px;">Confirm back to default template cancel or confirm them ?</p>
                    </v-card-text>
                    <v-card-actions class="grey darken-4">
                      <v-spacer />
                      <v-btn
                        color="red"
                        style="outline: none; text-transform: none;"
                        outline
                        @click="conBackToDefault = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        color="green darken-1"
                        style="outline: none; text-transform: none;"
                        @click="backToDefault()"
                      >
                        Confirm
                      </v-btn>
                  </v-card-actions>
              </v-card>
        </v-dialog>

        <v-dialog v-model="deletemode" persistent max-width="210px">
          <v-layout justify-center>
            <v-card>
              <v-card-title>Confirm Delete</v-card-title>
              <v-card-actions>
                <v-btn color="primary" style="outline: none;" dark @click="deleteRule()">confirm</v-btn>
                <v-btn color="grey darken-1" style="outline: none;" flat dark @click="deletemode=false">
                  <u>cancel</u>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-layout>
        </v-dialog>
        <v-dialog v-model="backToDefaultmode" max-width="600px" max-height="300px">
          <!-- <loading :active.sync="editAlertLoading"
            :can-cancel="false"
          />-->
          <v-form ref="formBackToDefault" v-model="validBackToDefault" lazy-validation>
            <v-card class="css-Select-Dashboard-Template" dark>
              <v-card-title
                mt-5
                style="position: initial; margin-top: 20px"
              >Select Template Dashboard</v-card-title>
              <v-card-text style="padding-top: 0px">
                <v-radio-group
                  v-model="templateSelect"
                  :rules="[v => !!v || 'Template is required']"
                  class="radio-Box"
                >
                  <v-radio
                    v-for="item in templateList"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  />
                </v-radio-group>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn slot="activator" style="outline: none;" flat icon @click="backToDefaultSelectTemplate()">
                  <v-icon>check</v-icon>
                </v-btn>
                <v-btn slot="activator" style="outline: none;" flat icon @click.native="backToDefaultmode=false">
                  <v-icon>cancel</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>

        <v-dialog v-model="showDialogEditChart" persistent max-width="1200px">
          <v-card dark>
            <v-toolbar flat>
              <v-toolbar-title>Edit Chart</v-toolbar-title>
              <v-spacer />
              <v-btn icon style="outline: none;" @click="showDialogEditChart = false, preview_slices_edit.pop()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-flex class="DialogEditAddChart" max-width="1100px">
                <v-layout row>
                  <v-flex ml-3 lg5 md5>
                    <DashboardDialogEditChart
                      :initial-slice="slice"
                      :index="selectedIndex"
                      :index_list="user_index"
                      :chart-type-options="chartType"
                      :chart-field-options="dashField"
                      :chart-field-byte-options="eventType"
                      :field-response="fieldResponse"
                      :sum-field-options="eventType"
                      @preview="previewEditChart"
                      @commit="commitEditChart"
                      @setRefreshIndex="getField"
                      @close="showDialogEditChart = false"
                    />
                  </v-flex>
                  <v-flex mr-1 lg7 md7>
                    <grid-layout
                      :layout.sync="preview_slices_edit"
                      :row-height="300"
                      :responsive="true"
                      :cols="{ lg:12, md:12, sm:12, xs:1, xxs:1 }"
                      :is-resizable="editMode"
                      class="position"
                    >
                      <grid-item
                        v-for="item in preview_slices_edit"
                        :key="item.slice_id"
                        :x="item.x"
                        :y="item.y"
                        :w="item.w"
                        :h="item.h"
                        :i="item.i"
                        class="chart-item-preview"
                      >
                        <component
                          :preview_slices_edit="preview_slices_edit"
                          :is="item.chartType"
                          :start-time="startTime"
                          :end-time="endTime"
                          :interval="interval"
                          :interval-time-bar="item.intervalTimeBar"
                          :field="item.field"
                          :chart-id="item.i"
                          :slice="item"
                          :fieldsum="item.fieldsum"
                          :options="item.options"
                          :field-custom="item.fieldCustom"
                          :options-custom="item.optionsCustom"
                          :fields="item.fields"
                          :orderby="item.orderby"
                          :chart-name="item.chartName"
                          :bar_line="item.bar_line"
                          :top-limit="item.topLimit"
                          :group="item.group"
                          :func="item.func"
                          :stores="stores"
                          :sub-filter="item.subFilter"
                          :text="text"
                          :field_st="item.field_st"
                          :field_nd="item.field_nd"
                          :user_inst="user_inst"
                          :lic="lic"
                          :user_index="item.index"
                          :index_now="selectedIndex"
                          class="chart-item-preview"
                        />
                      </grid-item>
                    </grid-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="showDialogFullChart" persistent max-width="930px">
          <v-card dark>
            <v-toolbar flat>
              <v-toolbar-title>Preview Chart</v-toolbar-title>
              <v-spacer />
              <v-btn
                icon
                style="outline: none;"
                @click="showDialogFullChart = false, expandchartSizeCustomText = false, preview_slices_full.pop()"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-actions v-if="slice.chartType !== 'x-timeBar' && slice.chartType !== 'x-map'">
              <v-spacer></v-spacer>
              <v-btn color="blue darken-2" style="outline: none;" @click="expandchartSize = 10 ,extandFullChart();">TOP10</v-btn>
              <v-btn color="blue darken-3" style="outline: none;" @click="expandchartSize = 20 ,extandFullChart();">TOP20</v-btn>
              <v-btn color="blue darken-4" style="outline: none;" @click="expandchartSize = 30 ,extandFullChart();">TOP30</v-btn>
              <v-btn
                v-if="!expandchartSizeCustomText"
                color="blue-grey"
                style="outline: none;"
                @click="expandchartSizeCustomText = true"
              >Custom</v-btn>
              <v-btn
                v-if="expandchartSizeCustomText"
                color="blue-grey"
                style="outline: none;"
                @click="expandchartSizeCustomText = false"
              >Custom</v-btn>
            </v-card-actions>
            <v-card-actions v-if="expandchartSizeCustomText">
              <v-spacer></v-spacer>
              <v-text-field
                class="shrink mx-4"
                v-model="expandchartSizeCustomValue"
                label="Size of Data"
                type="number"
                style="min-width: 80px;"
                :rules="rulessankey"
                min="1"
                max="30"
                required
              />
              <v-btn
                color="blue-grey"
                fab
                style="outline: none;"
                @click="expandchartSize = parseInt(expandchartSizeCustomValue) ,extandFullChart()"
              >
                <v-icon>forward</v-icon>
              </v-btn>
            </v-card-actions>
            <v-card-text>
              <v-flex class="DialogFullChart" max-width="930px">
                <v-layout>
                  <v-flex>
                    <grid-layout
                      :layout.sync="preview_slices_full"
                      :row-height="heightFullChart"
                      :responsive="true"
                      :is-draggable="false"
                      :is-resizable="false"
                      class="position"
                    >
                      <grid-item
                        v-for="item in preview_slices_full"
                        :key="item.slice_id"
                        :x="item.x"
                        :y="item.y"
                        :w="item.w"
                        :h="item.h"
                        :i="item.i"
                        class="chart-item-preview"
                      >
                        <component
                          :preview_slices_full="preview_slices_full"
                          :is="item.chartType"
                          :start-time="startTime"
                          :end-time="endTime"
                          :interval="interval"
                          :interval-time-bar="item.intervalTimeBar"
                          :field="item.field"
                          :chart-id="item.i"
                          :slice="item"
                          :fieldsum="item.fieldsum"
                          :options="item.options"
                          :field-custom="item.fieldCustom"
                          :options-custom="item.optionsCustom"
                          :fields="item.fields"
                          :orderby="item.orderby"
                          :chart-name="item.chartName"
                          :bar_line="item.bar_line"
                          :top-limit="expandchartSize"
                          :group="item.group"
                          :func="item.func"
                          :stores="stores"
                          :sub-filter="item.subFilter"
                          :text="text"
                          :field_st="item.field_st"
                          :field_nd="item.field_nd"
                          :user_inst="user_inst"
                          :lic="lic"
                          :user_index="item.index"
                          :index_now="selectedIndex"
                          :previewMode="true"
                          class="chart-item-preview"
                        />
                      </grid-item>
                    </grid-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-card-text>
            <!-- <v-divider></v-divider>
            <v-card-actions v-if="slice.chartType !== 'x-timeBar' && slice.chartType !== 'x-map'">
              <v-spacer></v-spacer>
              <v-btn color="indigo" style="outline: none;" @click="expandchartSize = 10 ,extandFullChart();">TOP10</v-btn>
              <v-btn color="indigo" style="outline: none;" @click="expandchartSize = 20 ,extandFullChart();">TOP20</v-btn>
              <v-btn color="indigo" style="outline: none;" @click="expandchartSize = 30 ,extandFullChart();">TOP30</v-btn>
              <v-btn
                v-if="!expandchartSizeCustomText"
                color="blue-grey"
                @click="expandchartSizeCustomText = true"
              >Custom</v-btn>
              <v-btn
                v-if="expandchartSizeCustomText"
                color="blue-grey"
                style="outline: none;"
                @click="expandchartSizeCustomText = false"
              >Custom</v-btn>
            </v-card-actions>
            <v-card-actions v-if="expandchartSizeCustomText">
              <v-spacer></v-spacer>
              <v-text-field
                class="shrink mx-4"
                v-model="expandchartSizeCustomValue"
                label="Size of Data"
                type="number"
                :rules="rulessankey"
                min="1"
                max="30"
                required
              />
              <v-btn
                color="blue-grey"
                fat
                style="outline: none;"
                @click="expandchartSize = parseInt(expandchartSizeCustomValue) ,extandFullChart()"
              >
                <v-icon>forward</v-icon>
              </v-btn>
            </v-card-actions> -->
          </v-card>
        </v-dialog>

        <SavedQuery
          v-model="showDialogSavedQuery"
          :fields="allDashField"
          :saved-searches="savedSearches"
          :user="username"
          @search="textSearch"
          @edit-saved-search="editSavedSearch"
          @open-saved-search="openSavedSearch"
          @get-saved-searches="getSavedSearches"
        />

        <SaveQuery
          v-model="showDialogSaveQuery"
          :mode="editSavedSearchMode"
          :saved-searches="savedSearches"
          :text="textTemp"
          :editing-command="editingCommand"
          @get-saved-searches="getSavedSearches"
        />
        <v-layout v-if="checkDashboard" column>
          <v-flex>
            <v-icon dark size="60">dashboard</v-icon>
          </v-flex>
          <v-flex column >
            <span style="color: #BDBDBD;">Your dashboard is empty !</span><br>
            <span style="color: #BDBDBD;">You can create your chart by edit mode
              <v-icon dark size="20" color="#BDBDBD">build</v-icon>
              on you right side.
            </span>
          </v-flex>
        </v-layout>
        <grid-layout
          v-else
          :layout.sync="slices"
          :row-height="305"
          :is-draggable="editMode"
          :is-resizable="editMode"
          :responsive="true"
          :cols="{ lg:12, md:12, sm:12, xs:1, xxs:1 }"
          class="position"
        >
          <!-- <h1 style="color: white;" v-if="true">Test</h1> -->
          <grid-item
            v-for="item in slices"
            :key="item.slice_id"
            :x="item.x"
            :y="item.y"
            :w="item.w"
            :h="item.h"
            :i="item.i"
            class="chart-item"
            dragAllowFrom=".chart-move"
            @init="initEvent"
            @resize="resizedEvent"
            @moved="movedEvent"
          >
            <component
              :ref="`${selectedIndex}-${item.i}`"
              :is="item.chartType"
              :start-time="startTime"
              :end-time="endTime"
              :interval="interval"
              :interval-time-bar="item.intervalTimeBar"
              :field="item.field"
              :chart-id="item.i"
              :slice="item"
              :fieldsum="item.fieldsum"
              :options="item.options"
              :field-custom="item.fieldCustom"
              :options-custom="item.optionsCustom"
              :fields="item.fields"
              :orderby="item.orderby"
              :chart-name="item.chartName"
              :bar_line="item.bar_line"
              :top-limit="item.topLimit"
              :group="item.group"
              :func="item.func"
              :stores="stores"
              :sub-filter="item.subFilter"
              :text="text"
              :field_st="item.field_st"
              :field_nd="item.field_nd"
              :edit-mode="editMode"
              :user_inst="user_inst"
              :lic="lic"
              :user_index="item.index"
              :username="username"
              :index_now="selectedIndex"
              :reloadchart="reloadchart"
              class="chart-item"
              @actionToChart="actionToChart"
              @setTime="setTime"
              @setkey="setkey"
              @setnewtime="setnewtime"
              @toNotification="toNotification"
              @loadChart="loadChart"
              @edit-chart="editChart"
              @full-chart="fullChart"
              @add-chart="addChart"
              @duplicate-chart="duplicateChart"
              @deleteChart="deleteChart"
            />
          </grid-item>
        </grid-layout>
      </v-tabs-items>
      <div id="down" />
    </div>

    <div v-else>
      <v-card class="license-card">
        <v-card-text>
          <v-layout class="license-expired" justify-center>
            <v-icon size="26" color="#424242" style="margin-right: 6px;">block</v-icon>
            <span>Your license has been expired. Please contact support iLog.</span>
          </v-layout>
        </v-card-text>
      </v-card>
    </div>

    <v-snackbar
      v-model="snackbar"
      :bottom="false"
      :left="false"
      :multi-line="true"
      :right="false"
      :timeout="6000"
      :top="true"
      :vertical="false"
    >
      {{ snackbartext }}
      <v-btn
        color="pink"
        flat
        style="outline: none;"
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>

  </v-container>
</template>

<script>
import { GridLayout, GridItem } from 'vue-grid-layout'
import jwtDecode from 'jwt-decode'
import axios from 'axios'
import XBar from '@/components/x-bar'
import XPie from '@/components/x-pie'
import XHbar from '@/components/x-hbar'
import XMap from '@/components/x-map'
import XSingle from '@/components/x-single'
import XSummary from '@/components/x-summary'
import topSearchBar from '@/components/topSearchBar'
import XTable from '@/components/x-table'
import XTableCustom from '@/components/x-tableCustom'
import XSankey from '@/components/x-sankey'
import XTimeBar from '@/components/x-timeBar'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import GQuery from '@/components/guideQuery'
import DashboardDialogAddChart from '@/components/DashboardDialogAddChart'
import DashboardDialogEditChart from '@/components/DashboardDialogEditChart'
import DashboardDialogCreateNewTemplate from '@/components/DashboardDialogCreateNewTemplate'
import ExportDashboard from '@/components/ExportDashboard'
import SavedQuery from '@/components/SavedQuery'
import SaveQuery from '@/components/SaveQuery'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
pdfMake.vfs = pdfFonts.pdfMake.vfs
pdfMake.fonts = {
  THSarabunNew: {
    bold: 'THSarabunNew-Bold.ttf',
    normal: 'THSarabunNew.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  },
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf'
  }
}

export default {
  name: 'DashboardPDPA',
  components: {
    ExportDashboard,
    GridLayout,
    GridItem,
    XBar,
    XPie,
    XMap,
    XSingle,
    XSummary,
    topSearchBar,
    XTable,
    XTableCustom,
    XHbar,
    XSankey,
    XTimeBar,
    VueCtkDateTimePicker,
    GQuery,
    DashboardDialogAddChart,
    DashboardDialogEditChart,
    DashboardDialogCreateNewTemplate,
    SavedQuery,
    SaveQuery,
    Loading
  },
  props: {
    isExpired: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      snackbar: false,
      snackbartext: '',
      // extandChart
      expandchartSize: 10,
      expandchartSizeCustomValue: 0,
      expandchartSizeCustomText: false,
      extandChartId: '',
      heightFullChart: 450,
      fullslice: {},
      extandslice: {},

      loadCount: 0,
      statusButton: true,
      guidequery: false,
      // alert button
      deletemode: false,
      setAlert: false,
      addAlertLoading: false,
      delchart: '',
      querytext: [],
      rulessankey: [
        (v) => !!v || 'Number is required',
        (v) => v >= 1 || 'Number be above 1',
        (v) => v <= 30 || 'Number should not be above 30'
      ],
      rulesnumber: [
        (v) => !!v || 'Number is required',
        (v) => v >= 0 || 'Interval less than 0',
        (v) => v.length <= 7 || 'Name must be less than 7 characters'
      ],
      rulestime: [
        (v) => !!v || 'Run Every in is required'
        // (v) => v !== 'M' || '* month fixable At 12:00AM on day 1 of the month'
      ],
      queryRule: [
        (v) => {
          if (!v || v.length === 0) {
            return 'Query is required'
          } else {
            return true
          }
        }
      ],
      yourValue: null,
      crontabInterval: '',
      intervals: '',
      ActionType: [
        {
          text: 'Alert Email',
          value: 'Email'
        }
      ],
      intervalalert: [],
      eventTrigger: '',
      eventType: [
        {
          text: 'Count',
          value: 'count'
        }
      ],
      alertType: [],
      fieldalet: '',
      unit: '',
      units: [
        {
          text: 'GB',
          value: 'GB'
        },
        {
          text: 'MB',
          value: 'MB'
        },
        {
          text: 'KB',
          value: 'KB'
        }
      ],
      IntervalTime: [
        {
          text: 'minute',
          value: 'm'
        },
        {
          text: 'hour',
          value: 'h'
        },
        {
          text: 'day',
          value: 'd'
        },
        {
          text: 'month',
          value: 'M'
        }
      ],
      alertInterval: '',
      number: '',
      alertTrigger: '',
      newAlertName: 'Untitled',
      targetField: '',
      Action: 'Email',
      email: '',
      deviceItem: [],
      /// dashboard
      dashboardselect: '',
      user_inst: null,
      text: '',
      textTemp: '',
      token: '',
      decoded: '',
      startTime: 'now-15m',
      endTime: 'now',
      interval: '10s',
      refreshTime: 0,
      keys: '',
      field: '',
      stores: [],
      selectedStores: [],
      trigger: true,
      settrue: true,
      user_index: [],
      export: false,
      tcca: false,
      username: '',
      selectedDashboard: '',
      slices: [],
      editMode: false,
      subFilter: '*',
      chartType: [
        {
          text: 'Pie Chart',
          value: 'x-pie'
        },
        {
          text: 'Bar Chart',
          value: 'x-bar'
        },
        {
          text: 'Horizontal Bar Chart',
          value: 'x-hbar'
        },
        {
          text: 'Sankey',
          value: 'x-sankey'
        },
        {
          text: 'RawEvent(Table)',
          value: 'x-table'
        },
        {
          text: 'SumEvent(Table)',
          value: 'x-tableCustom'
        },
        {
          text: 'Summary Event',
          value: 'x-summary'
        },
        {
          text: 'Time Bar Event',
          value: 'x-timeBar'
        },
        {
          text: 'Geo-Map By Destination IP',
          value: 'x-map'
        }
      ],
      dashField: [],
      chartFunc: ['Count', 'byte'],
      chartFuncPie: ['Count'],
      fixHeight: [],
      fieldByte: [],
      fieldResponse: '',
      savetemplateMode: false,
      savetemplatePopup: false,
      responeSave: '',
      items: [
        {
          value: ''
        }
      ],
      tab: null,
      selectedIndex: '',
      tabIndex: 0,
      card: false,
      showDialogAddChart: false,
      showDialogEditChart: false,
      showDialogFullChart: false,
      showDialogFullMap: false,
      showDialogSavedQuery: false,
      showDialogSaveQuery: false,
      slice: {},
      refreshInterval: null,
      validAddAlert: true,
      nameRules: [
        (v) => !!v || 'Name is required',
        (v) => (v && v.length <= 30) || 'Name must be less than 30 characters'
      ],
      storesSlice: [],
      saveStatus: false,
      backToDefaultmode: false,
      templateList: [],
      templateSelect: '',
      validBackToDefault: true,
      selectTimenew: [],
      class_css: 'css-editMode-Close', // class css for editMode
      // Create New Template
      createNewTemplate: false,
      stagNewTemplate: false,
      stageTabIndex: 0,
      check: 0,
      preview_slices_add: [],
      preview_slices_edit: [],
      preview_slices_full: [],
      field_used: [],
      show_all_field: false,
      // Export
      sortedSlices: [],
      exportingCharts: [],
      exportingChartsImages: [],
      logAVG: 0,
      logRetention: 0,
      bytePerEvent: 0,
      GB_Per_day: false,
      interval_GB_Per_day: 0,
      startTime_Report: null,
      endTime_Report: null,
      isLoading: false,
      // Save Query
      alertField: [],
      allDashField: [],
      savedSearches: [],
      editingCommand: {},
      editSavedSearchMode: 'Save',
      customSearchFromAlert: '',
      setDatePickerFromAlert: null,
      checkDashboard: false,
      ampid: '',
      shownDialogDiscardChanges: false,
      stateEdit: false,
      conBackToDefault: false,
      clearField: false,
      keySearchEg: '',
      reloadchart: false
    }
  },
  async created () {
    this.token = sessionStorage.getItem('user-token')
    this.decoded = jwtDecode(this.token)
    this.ampid = this.decoded.ampid
    this.customSearchFromAlert = JSON.parse(sessionStorage.getItem('iLog-search'))
    this.username = this.decoded.username
    // this._id = this.decoded._id
    this.lic = Number(this.decoded.lic)
    this.role = this.decoded.role
    this.user_inst = this.decoded.instance
    this.isExpired = this.decoded.isExpired
    //   window.addEventListener('beforeunload', function (e) {
    //     e.preventDefault()
    //     e.returnValue = window.confirm('Do you really want to leave?')
    // }, false)
    if (this.$route.params.id) {
      this._id = this.$route.params.id
    } else {
      this._id = this.decoded._id
    }
    if (this.customSearchFromAlert) {
      if (!this.isExpired) {
        this.textTemp = this.customSearchFromAlert.text
        this.setDatePickerFromAlert = this.customSearchFromAlert
        await this.getSavedSearches()
        await this.getIndex()
        await this.getDashboardTemplate()
        await this.getField(this.user_index[this.tabIndex], false)
        await this.getSearcheg()
        // if (this.user_index) {
        //   for (let element of this.user_index) {
        //     let object = {
        //       text: element,
        //       value: element
        //     }
        //     this.deviceItem.push(object)
        //   }
        // }
        let findIndex = this.user_index.findIndex(el => el === this.customSearchFromAlert.device)
        if (findIndex !== -1) {
          this.tabIndex = findIndex
        }
        this.textSearch()
        sessionStorage.removeItem('iLog-search')
      }
    } else {
      if (!this.isExpired) {
        await this.getIndex()
        await this.getSavedSearches()
        await this.getDashboardTemplate()
        await this.getField(this.user_index[this.tabIndex], false)
        await this.getSearcheg()
        // if (this.user_index) {
        //   for (let element of this.user_index) {
        //     let object = {
        //       text: element,
        //       value: element
        //     }
        //      this.deviceItem.push(object)
        //   }
        // }
      }
    }
  },
  methods: {
    async getSavedSearches () {
      const response = await axios.get(apiUrl + '/api/dashboard/saved-searches')
        // .catch((error) => {
        //   // alert(error)
        //   this.snackbartext = error
        //   this.snackbar = true
        //   })
      this.savedSearches = response.data.savedSearches || []
    },
    async getField (index, show_all_field) {
      // console.log(index)
      // console.log(show_all_field)
      this.show_all_field = show_all_field
      this.dashField = []
      this.fieldByte = []
      this.alertField = []
      this.fieldByte.push({
        text: 'Count',
        value: 'count'
      })
      let field = []
      if (this.$route.params.username !== undefined) {
        // eslint-disable-next-line
        show_all_field === undefined ? false : show_all_field
        this.dashboardselect = await this.$route.params.index_name
        if (
          this.$route.params.index_name !== this.user_index[this.tabIndex] &&
          this.user_index[this.tabIndex] === index
        ) {
          this.dashboardselect = this.user_index[this.tabIndex]
        } else if (index) {
          this.dashboardselect = index
        }
        let response = await axios.post(apiUrl + '/api/query/allfield', {
          index: this.dashboardselect,
          instance: this.$route.params.user_inst
        })
        for (let [value, element] of response.data.entries()) {
          if (element === 'geoip') {
            field = response.data.splice(value, 1, 'geoip.country_name')
          } else {
            field = response.data
          }
        }
      } else if (index) {
        let response = await axios.post(apiUrl + '/api/query/allfield', {
          index: index,
          instance: this.user_inst
        })
        for (let [value, element] of response.data.entries()) {
          if (element === 'geoip') {
            field = response.data.splice(value, 1, 'geoip.country_name')
          } else {
            field = response.data
          }
        }
      } else {
        let response = await axios.post(apiUrl + '/api/query/allfield', {
          index: this.user_index[this.tabIndex],
          instance: this.user_inst
        })
        for (let [value, element] of response.data.entries()) {
          if (element === 'geoip') {
            field = response.data.splice(value, 1, 'geoip.country_name')
          } else {
            field = response.data
          }
        }
      }
      this.alertField = field
      for (let [value, element] of this.alertField.entries()) {
        if (element === '_raw' || element === '@version') {
          this.alertField.splice(value, 1)
        }
      }
      if (show_all_field === false) {
        for (let key in field) {
          if (field.hasOwnProperty(key)) {
            switch (field[key]) {
              case 'src_ip':
                this.dashField.push({
                  text: 'Source IP (e.g. 192.168.0.1)',
                  value: 'src_ip'
                })
                break
              case 'ip':
                this.dashField.push({
                  text: 'IP (e.g. 192.168.0.1)',
                  value: 'ip'
                })
                break
              case 'dest_ip':
                this.dashField.push({
                  text: 'Destination IP (e.g. 192.168.0.1)',
                  value: 'dest_ip'
                })
                break
              case 'src_port':
                this.dashField.push({
                  text: 'Source Port (e.g. 5550 ,42584)',
                  value: 'src_port'
                })
                break
              case 'dest_port':
                this.dashField.push({
                  text: 'Destination Port (e.g. 80 ,443)',
                  value: 'dest_port'
                })
                break
              case 'action':
                this.dashField.push({
                  text: 'Action (e.g. allow ,deny)',
                  value: 'action'
                })
                break
              case 'app':
                this.dashField.push({
                  text: 'Application (e.g. facebook ,line)',
                  value: 'app'
                })
                break
              case 'appcat':
                this.dashField.push({
                  text: 'Application Catagory (e.g. Social Network)',
                  value: 'appcat'
                })
                break
              case 'cs_categories':
                this.dashField.push({
                  text: 'Application Catagory (e.g. Social Network)',
                  value: 'cs_categories'
                })
                break
              case 'src_user':
                this.dashField.push({
                  text: 'Source User (e.g. Tom ,Mark)',
                  value: 'src_user'
                })
                break
              case 'dest_user':
                this.dashField.push({
                  text: 'Destination User (e.g. Tom ,Mark)',
                  value: 'dest_user'
                })
                break
              case 'user':
                this.dashField.push({
                  text: 'User (e.g. Tom ,Mark)',
                  value: 'user'
                })
                break
              case 'username':
                this.dashField.push({
                  text: 'User (e.g. Tom ,Mark)',
                  value: 'username'
                })
                break
              case 'client_ip':
                this.dashField.push({
                  text: 'Client IP (e.g. 192.168.0.1)',
                  value: 'client_ip'
                })
                break
              case 'event_name':
                this.dashField.push({
                  text: 'Action (e.g. Send ,Fail)',
                  value: 'event_name'
                })
                break
              case 'sender_address':
                this.dashField.push({
                  text: 'Sender Email (e.g. abc@xyz.com)',
                  value: 'sender_address'
                })
                break
              case 'recp_address':
                this.dashField.push({
                  text: 'Recipient Email (e.g. abc@xyz.com)',
                  value: 'recp_address'
                })
                break
              case 'protocol':
                this.dashField.push({
                  text: 'Protocol (e.g. udp ,tcp)',
                  value: 'protocol'
                })
                break
              case 'interface':
                this.dashField.push({
                  text: 'interface (e.g. em0 ,re0)',
                  value: 'interface'
                })
                break
              case 'http_status':
                this.dashField.push({
                  text: 'HTTP Status (e.g. 200 ,403)',
                  value: 'http_status'
                })
                break
              case 'http_method':
                this.dashField.push({
                  text: 'HTTP Method (e.g. GET ,POST)',
                  value: 'http_method'
                })
                break
              case 'method':
                this.dashField.push({
                  text: 'HTTP Method (e.g. GET ,POST)',
                  value: 'method'
                })
                break
              case 'policy_id':
                this.dashField.push({
                  text: 'Policy ID (e.g. 70 ,28)',
                  value: 'policy_id'
                })
                break
              case 'catagory':
                this.dashField.push({
                  text: 'Event Catagory (e.g. System ,Security)',
                  value: 'catagory'
                })
                break
              case 'deviceHostName':
                this.dashField.push({
                  text: 'Device HostName (e.g. PA3020Node1 ,iLog-AD01)',
                  value: 'deviceHostName'
                })
                break
              case 'DeviceName':
                this.dashField.push({
                  text: 'Device HostName (e.g. PA3020Node1 ,iLog-AD01)',
                  value: 'DeviceName'
                })
                break
              case 'hostname':
                this.dashField.push({
                  text: 'Device HostName (e.g. PA3020Node1 ,iLog-AD01)',
                  value: 'hostname'
                })
                break
              case 'dev_name':
                this.dashField.push({
                  text: 'Device HostName (e.g. PA3020Node1 ,iLog-AD01)',
                  value: 'dev_name'
                })
                break
              case 'geoip.country_name':
                this.dashField.push({
                  text: 'Destination Country (e.g. USA ,Canada)',
                  value: 'geoip.country_name'
                })
                break
              case 'dest_country':
                this.dashField.push({
                  text: 'Destination Country (e.g. USA ,Canada)',
                  value: 'dest_country'
                })
                break
              case 'dest_interface':
                this.dashField.push({
                  text: 'Destination Interface (e.g. Port1 ,Port2)',
                  value: 'dest_interface'
                })
                break
              case 'dev_type':
                this.dashField.push({
                  text: 'Device Type (e.g. Windows ,Linux)',
                  value: 'dev_type'
                })
                break
              case 'service':
                this.dashField.push({
                  text: 'Service (e.g. HTTP ,DNS)',
                  value: 'service'
                })
                break
              case 'type':
                this.dashField.push({
                  text: 'Event Type (e.g. Event ,Traffic)',
                  value: 'type'
                })
                break
              case 'urlPath':
                this.dashField.push({
                  text: 'URL (e.g. index.php ,example.html)',
                  value: 'urlPath'
                })
                break
              case 'url':
                this.dashField.push({
                  text: 'URL Host(e.g. www.example.com)',
                  value: 'url'
                })
                break
              case 'ContentType':
                this.dashField.push({
                  text: 'Content Type (e.g. image/png ,text/html)',
                  value: 'ContentType'
                })
                break
              case 'rs_content_type':
                this.dashField.push({
                  text: 'Content Type (e.g. image/png ,text/html)',
                  value: 'rs_content_type'
                })
                break
              case 'message_subject':
                this.dashField.push({
                  text: 'Email Subject (e.g. MoM iLog ,Open Portal)',
                  value: 'message_subject'
                })
                break
              case 'statusDESC':
                this.dashField.push({
                  text: 'status DESC (e.g. Found ,Not Found)',
                  value: 'statusDESC'
                })
                break
              case 'request':
                this.dashField.push({
                  text: 'Path Request (e.g. /index.html ,home.php)',
                  value: 'request'
                })
                break
            }
          }
        }
      } else {
        this.dashField = field
      }
      for (var i = 0; i < field.length; i++) {
        if (field[i].indexOf('byte') >= 0) {
          if (field[i] === 'bytes_in') {
            this.eventType.push({
              text: 'Download',
              value: 'download'
            })
            this.fieldByte.push({
              text: 'Download',
              value: 'bytes_in'
            })
          } else if (field[i] === 'bytes_out') {
            this.eventType.push({
              text: 'Upload',
              value: 'upload'
            })
            this.fieldByte.push({
              text: 'Upload',
              value: 'bytes_out'
            })
          }
        }
      }
      if (this.fieldByte.length < 1) {
        this.fieldResponse =
          'No bytes fields Please select another math function.'
      } else {
        this.fieldResponse = 'Please Select bytes fields'
      }
      // for (let [value, element] of this.dashField.entries()) {
      //   if (element === '@timestamp') {
      //     this.dashField.splice(value, 1)
      //     break
      //   }
      // }
    },
    deleteItem (fieldid) {
      this.items.splice(fieldid, 1)
    },
    async getDashboardTemplate () {
      this.slices = []
      if (this.$route.params.username !== undefined) {
        this.user_index = this.$route.params.index_list
        for (let [value, key] of this.user_index.entries()) {
          if (this.$route.params.index_name === key) {
            if (this.check === 0) {
              this.tabIndex = value
              this.check++
              break
            }
          }
        }
        // for (let key in this.user_index) { // eslint-disable-line
        //   if (this.$route.params.index_name !== this.user_index[this.tabIndex]) {
        //     this.tabIndex++
        //   }
        // }
        let response = await axios.post(
          apiUrl + '/api/dashboard/loadtemplate',
          {
            username: this.$route.params.username,
            selectedDashboard: this.user_index[this.tabIndex],
            type: 'alldashboard'
          }
        )
        response.data.success ? this.checkDashboard = false : this.checkDashboard = true
        setTimeout(() => {
          this.user_inst = this.$route.params.user_inst
          this.selectedIndex = this.user_index[this.tabIndex]
          if (response.data.success) {
            this.slices = response.data.slices
            this.storesSlice = response.data.slices
          } else {
            this.slices = []
            this.storesSlice = []
          }
        }, 400)
      } else {
        let response = await axios.post(
          apiUrl + '/api/dashboard/loadtemplate',
          {
            username: this.username,
            selectedDashboard: this.user_index[this.tabIndex]
          }
        )
        response.data.success ? this.checkDashboard = false : this.checkDashboard = true
        setTimeout(() => {
          this.selectedIndex = this.user_index[this.tabIndex]
          if (response.data.success) {
            this.slices = response.data.slices
            this.storesSlice = response.data.slices
          } else {
            this.slices = []
            this.storesSlice = []
          }
        }, 400)
      }
    },
    async setQuey () {
      window.analytics.track(`[Feature][SetAlert]`, {}, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
      this.$refs.formAddAlert.resetValidation()
      this.setAlert = true
      this.querytext = []
      if (this.textTemp !== '' && this.stores.length === 0) {
        let k = this.textTemp.match(/([^\s]+)/g)
        for (let o = 0; o < k.length; o++) {
          this.querytext.push(`text: ${k[o]}`)
        }
      } else if (this.stores.length !== 0 && this.textTemp === '') {
        this.querytext = this.selectedStores
      } else {
        let k = this.textTemp.match(/([^\s]+)/g)
        if (k === null) {
          for (let k = 0; k < this.selectedStores.length; k++) {
            this.querytext.push(this.selectedStores[k])
          }
        } else {
          for (let o = 0; o < k.length; o++) {
            this.querytext.push(`text: ${k[o]}`)
          }
          for (let k = 0; k < this.selectedStores.length; k++) {
            this.querytext.push(this.selectedStores[k])
          }
        }
      }
    },
    remove (item) {
      this.querytext.splice(this.querytext.indexOf(item), 1)
      this.querytext = [...this.querytext]
    },
    async setAlerts (method) {
      if (this.$refs.formAddAlert.validate()) {
        this.addAlertLoading = true
        let frequency = this.intervals
        let exactTime = this.yourValue
          ? this.yourValue.split(':') : (this.querytext = this.querytext.map((filter) =>
              filter.includes(':') ? filter : `text: ${filter}`
            ))
        this.crontabInterval = exactTime
          ? {
              m: `*/${frequency} * * * *`,
              h: `0 */${frequency} * * *`,
              d: `${exactTime[1]} ${exactTime[0]} */${frequency} * *`,
              M: `0 0 1 */${frequency} *`
            }[this.alertInterval]
          : {
              m: `*/${frequency} * * * *`,
              h: `0 */${frequency} * * *`,
              M: `0 0 1 */${frequency} *`
            }[this.alertInterval]
        let request = {
          name: this.newAlertName,
          query: this.querytext,
          selectedIndex: this.selectedIndex,
          trigger: this.alertTrigger,
          number: this.number * 1,
          unit: this.unit,
          eventTrigger: this.eventTrigger,
          targetField: this.targetField,
          fieldalet: this.fieldalet,
          intervals: this.crontabInterval,
          alertInterval: this.alertInterval,
          setintervals: this.intervals,
          action: this.Action,
          email: this.email,
          type: 'pdpa'
        }
        try {
          let response
          if (method === 'test') {
            response = await axios.post(
              apiUrl + '/api/query/testAlert/' + this._id,
              request
            )
            window.analytics.track(`Click][Feature][SetAlert][Test Alert]`, {
              value: {
                id: this._id,
                name: request.name,
                index: request.selectedIndex
              }
            }, {
              integrations: {
                  Amplitude: {
                    'session_id': this.ampid
                  }
                }
              })
          } else {
            response = await axios.put(
              apiUrl + '/api/query/setAlerts/' + this._id,
              request
            )
            window.analytics.track(`[Feature][SetAlert][Submit]`, {
              value: {
                id: this._id,
                name: request.name,
                index: request.selectedIndex
              }
            }, {
              integrations: {
                  Amplitude: {
                    'session_id': this.ampid
                  }
                }
              })
          }
          // let response =
          //   method === 'test'
          //     ? await axios.post(
          //         apiUrl + '/api/query/testAlert/' + this._id,
          //         request
          //       )
          //     : await axios.put(
          //         apiUrl + '/api/query/setAlerts/' + this._id,
          //         request
          //       )
          if (response) {
            if (method === 'test') {
              this.setAlert = true
            } else {
              this.toNotification({
                name: this.newAlertName,
                query: this.querytext,
                selectedIndex: this.selectedIndex,
                trigger: this.alertTrigger,
                number: this.number * 1,
                intervals: this.crontabInterval,
                alertInterval: this.alertInterval,
                setintervals: this.intervals,
                action: this.Action,
                email: this.email
              })
              this.setAlert = false
            }
            this.addAlertLoading = false
            this.snackbartext = response.data.message
            this.snackbar = true
            // setTimeout(function () {
            //   // alert(response.data.message)
            //   this.snackbartext = response.data.message
            //   this.snackbar = true
            // }, 100)
          }
        } catch (error) {
          console.log(error)
          // alert('Error Type: ' + error)
          this.snackbartext = `'Error Type: ' + ${error}`
          this.snackbar = true
        }
      }
    },
    clickCloseSetalert () {
      window.analytics.track(`[Feature][SetAlert][Close]`, {}, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
    },
    setTime (start, end, int) {
      let data =
        typeof start === 'number'
          ? {
              start: new Date(start).toString(),
              end: new Date(end).toString()
            }
          : {
              start,
              end
            }
      axios.post(apiUrl + '/api/dashboard/stage', {
        type: 'date',
        action: 'DatePicker',
        username: this.username,
        index: this.user_index[this.tabIndex],
        data: data
      })
      this.startTime = start
      this.endTime = end
      this.interval = int
    },
    setRefreshTime (refreshTime) {
      let mode = refreshTime === 0 ? 'off' : 'on'
      axios.post(apiUrl + '/api/dashboard/stage', {
        type: 'time',
        action: 'AutoRefresh',
        username: this.username,
        index: this.user_index[this.tabIndex],
        mode: mode,
        interval: refreshTime
      })
      if (refreshTime === 0) {
        clearInterval(this.refreshInterval)
      } else {
        clearInterval(this.refreshInterval)
        this.refreshInterval = setInterval(
          function () {
            this.getDashboardTemplate()
          }.bind(this),
          refreshTime
        )
      }
    },
    initEvent (i, H, W, HPx, WPx) {
      this.slices = this.slices.map((item) => {
        if (item.i === i) {
          item.width = WPx
          item.height = HPx
        }
        return item
      })
    },
    resizedEvent (i, newW, newWPx) {
      window.analytics.track('[Setting][EditChat][Resize]', {
        value: {
          chart: i
        }
      }, {
        integrations: {
          Amplitude: {
            'session_id': this.ampid
          }
        }
      })
      this.slices = this.slices.map((item) => {
        if (item.i === i) {
          item.width = newWPx
        }
        return item
      })
      this.stateEdit = true
    },
    movedEvent (i, newX, newY) {
      for (let [index, slice] of this.slices.entries()) {
        if (slice.i === i) {
          axios.post(apiUrl + '/api/dashboard/stage', {
            type: 'chart',
            action: 'MoveVisualize',
            username: this.username,
            index: this.user_index[this.tabIndex],
            data: this.slices[index]
          })
          window.analytics.track('[Setting][EditChat][Move]', {
            value: {
              chart: this.slices[index]
            }
          }, {
            integrations: {
              Amplitude: {
                'session_id': this.ampid
              }
            }
          })
        }
      }
      this.stateEdit = true
    },
    clearfilter () {
      this.stores = []
      this.selectedStores = []
      this.selectTimenew = []
      this.text = ''
      this.textTemp = ''
      this.interval = '10s'
      this.clearField = true
    },
    setkey (startTime, endTime, key, field) {
      this.startTime = startTime
      this.endTime = endTime
      this.keys = key
      this.field = field
      this.pushstores()
      // if (!this.editMode) {
      //   this.pushstores()
      // }
    },
    setnewtime (timeSt, timeEn, timeInt) {
      if (!this.editMode) {
        this.selectTimenew = []
        this.selectTimenew.push(
          `Start Time: ${new Date(timeSt).toString()} To End Time: ${new Date(
            timeEn
          ).toString()}`
        )
        this.startTime = timeSt
        this.endTime = timeEn
        this.interval = timeInt
      }
    },
    deleteRule () {
      for (let [index, slice] of this.slices.entries()) {
        if (slice.i === this.delchart) {
          axios.post(apiUrl + '/api/dashboard/stage', {
            type: 'chart',
            action: 'DeleteVisualize',
            username: this.username,
            index: this.user_index[this.tabIndex],
            data: this.slices[index]
          })
          this.slices.splice(index, 1)
          window.analytics.track('[Setting][EditChat][Delete][Submit]', {
            value: {
              chart: this.slices[index]
            }
          }, {
            integrations: {
              Amplitude: {
                'session_id': this.ampid
              }
            }
          })
        }
      }
      this.deletemode = false
    },
    editChart (chartId) {
      window.analytics.track(`[Setting][EditChat][Edit]`, {
        value: {
          chart: chartId
        }
      }, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
      this.preview_slices_edit.pop()
      this.slice = this.slices.find((slice) => slice.i === chartId) // Store the old slice to provision the data in the dialog
      let newSlice = JSON.parse(JSON.stringify(this.slice))
      newSlice.slice_id = this.slice.chartType + new Date().getTime().toString()
      newSlice.i = this.slice.chartType + new Date().getTime().toString()
      newSlice.y = 9
      newSlice.w = 12
      newSlice.h = 1.2
      this.preview_slices_edit.push(newSlice)
      this.showDialogEditChart = true // Show the edit chart dialog
      this.stateEdit = true
    },
    addChart (chartId) {
      this.preview_slices_add.pop()
      this.slice = this.slices.find((slice) => slice.i === chartId) // Store the old slice to provision the data in the dialog
      let newSlice = JSON.parse(JSON.stringify(this.slice))
      newSlice.slice_id = this.slice.chartType + new Date().getTime().toString()
      newSlice.i = this.slice.chartType + new Date().getTime().toString()
      newSlice.y = 9
      newSlice.w = 12
      newSlice.h = 1.2
      this.preview_slices_add.push(newSlice)
      this.showDialogAddChart = true // Show the add chart dialog
      this.stateEdit = true
    },
    extandFullChart () {
      if (this.expandchartSize !== 0 && this.expandchartSize < 31) {
        this.preview_slices_full.pop()
        this.extandslice = this.slices.find(
          (slice) => slice.i === this.extandChartId
        ) // Store the old slice to provision the data in the dialog
        let newSlice = JSON.parse(JSON.stringify(this.extandslice))
        newSlice.slice_id =
          this.extandslice.chartType + new Date().getTime().toString()
        newSlice.i =
          this.extandslice.chartType + new Date().getTime().toString()
        newSlice.y = 9
        newSlice.w = 12
        newSlice.h = 1.2
        this.preview_slices_full.push(newSlice)
        this.showDialogFullChart = true // Show the full chart dialog
      } else {
      }
    },
    fullChart (chartId) {
      this.expandchartSize = 10
      this.preview_slices_full.pop()
      this.fullslice = this.slices.find((fullslice) => fullslice.i === chartId) // Store the old slice to provision the data in the dialog
      this.extandChartId = chartId
      if (this.fullslice.chartType === 'x-sankey') {
        this.heightFullChart = 780
      } else {
        this.heightFullChart = 450
      }
      let newSlice = JSON.parse(JSON.stringify(this.fullslice))
      newSlice.slice_id =
        this.fullslice.chartType + new Date().getTime().toString()
      newSlice.i = this.fullslice.chartType + new Date().getTime().toString()
      newSlice.y = 9
      newSlice.w = 12
      newSlice.h = 1.2
      this.preview_slices_full.push(newSlice)
      this.showDialogFullChart = true
    },
    duplicateChart (slice) {
      window.analytics.track(`[Setting][EditChat][Duplicate]`, {
        value: {
          chart: slice
        }
      }, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
      let newSlice = JSON.parse(JSON.stringify(slice))
      newSlice.slice_id = slice.chartType + new Date().getTime().toString()
      newSlice.i = slice.chartType + new Date().getTime().toString()
      newSlice.y = this.findMaxY() + 1
      axios.post(apiUrl + '/api/dashboard/stage', {
        type: 'chart',
        action: 'DuplicateVisualize',
        username: this.username,
        index: this.user_index[this.tabIndex],
        data: slice
      })
      this.slices.push(newSlice)
      this.loadChart('duplicate', this.slices.length)
      this.stateEdit = true
    },
    previewEditChart (slice) {
      this.preview_slices_edit.pop()
      let newSlice = JSON.parse(JSON.stringify(slice))
      newSlice.slice_id = this.slice.chartType + new Date().getTime().toString()
      newSlice.i = this.slice.chartType + new Date().getTime().toString()
      newSlice.y = 9
      newSlice.w = 12
      newSlice.h = 1.2
      this.preview_slices_edit.push(newSlice)
    },
    previewAddChart (slice) {
      this.preview_slices_add.pop()
      let newSlice = JSON.parse(JSON.stringify(slice))
      newSlice.slice_id = this.slice.chartType + new Date().getTime().toString()
      newSlice.i = this.slice.chartType + new Date().getTime().toString()
      newSlice.y = 9
      newSlice.w = 12
      newSlice.h = 1.2
      this.preview_slices_add.push(newSlice)
    },
    commitAddChart (slice) {
      // console.log(slice)
      window.analytics.track(`[Setting][AddChart][Submit]`, {
        value: {
          type: 'chart',
          action: 'CreateVisualize',
          username: this.username,
          index: this.user_index[this.tabIndex],
          data: slice
        }
      }, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
      axios.post(apiUrl + '/api/dashboard/stage', {
        type: 'chart',
        action: 'CreateVisualize',
        username: this.username,
        index: this.user_index[this.tabIndex],
        data: slice
      })
      this.slices.push(slice)
      this.showDialogAddChart = false
      this.loadChart('add', this.slices.length)
    },
    commitEditChart (slice) {
      // Replace the old slice with the user-edited slice
      axios.post(apiUrl + '/api/dashboard/stage', {
        type: 'chart',
        action: 'EditVisualize',
        username: this.username,
        index: this.user_index[this.tabIndex],
        data: slice
      })
      let chartId = slice.i
      let sliceIndex = this.slices.findIndex((slice) => slice.i === chartId)
      this.slices.splice(sliceIndex, 1, slice)
      this.showDialogEditChart = false // Hide the edit chart dialog
      this.loadChart('edit', this.slices.length)
    },
    commitAddTemplate (slice, addname) {
      this.user_index.push(addname)
      this.tabIndex = this.user_index.length - 1
      this.slices = slice
      this.stagNewTemplate = true
      this.createNewTemplate = false
    },
    FuncAddTemplate () {
      window.analytics.track(`[Setting][CreateTemplate]`, {}, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
      if (this.stagNewTemplate === true) {
        this.savetemplateMode = true
      } else {
        this.createNewTemplate = true
      }
    },
    async discard () {
      window.analytics.track(`[Setting][SaveDashboard][Close]`, {}, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
      await this.getIndex()
      this.savetemplateMode = false
      this.stagNewTemplate = false
      // this.tabIndex = this.stageTabIndex
      this.getDashboardTemplate()
      // this.stageTabIndex = 0
      this.shownDialogDiscardChanges = false
      this.stateEdit = false
    },
    deleteChart (chart) {
      this.deletemode = true
      this.delchart = chart
      this.stateEdit = true
    },
    loadChart (type, chart) {
      this.statusButton = true
      // if type !== load chart == slice.length
      // if (type === 'load') {
      //   this.loadCount++
      //   if (this.loadCount === this.slices.length) {
      //     this.statusButton = false
      //     this.loadCount = 0
      //   } else {
      //     this.statusButton = true
      //   }
      // } else if (type === 'add') {
      //   this.statusButton = true
      //   this.loadCount = chart - 1
      // } else if (type === 'edit') {
      //   this.statusButton = true
      //   this.loadCount = chart - 1
      // } else if (type === 'duplicate') {
      //   this.statusButton = true
      //   this.loadCount = chart - 1
      // }
    },
    findMaxY () {
      return this.slices.reduce(
        (max, slice) => (slice.y > max ? slice.y : max),
        this.slices[0].y
      )
    },
    async saveDashboard () {
      if (
        this.username !== this.$route.params.username &&
        this.$route.params.username !== undefined
      ) {
        let response = await axios.post(apiUrl + '/api/dashboard/save', {
          username: this.$route.params.username,
          dashboardName: this.user_index[this.tabIndex],
          slices: this.slices,
          type: 'alldashboard'
        })
        window.analytics.track(`[Setting][SaveDashboard][Save]`, {
          value: {
            username: this.$route.params.username,
            dashboardName: this.user_index[this.tabIndex],
            slices: this.slices,
            type: 'alldashboard'
          }
        }, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        })
        this.savetemplatePopup = true
        this.responeSave = response.data.msg
      } else if (this.$route.params.username === undefined) {
        if (this.stagNewTemplate === true) {
          let response = await axios.post(apiUrl + '/api/dashboard/save', {
            username: this.username,
            dashboardName: this.user_index[this.tabIndex],
            index: this.user_index,
            slices: this.slices
          })
          window.analytics.track(`[Setting][SaveDashboard][Save]`, {
            value: {
              username: this.username,
              dashboardName: this.user_index[this.tabIndex],
              index: this.user_index,
              slices: this.slices
            }
          }, {
            integrations: {
                Amplitude: {
                  'session_id': this.ampid
                }
              }
            })
          this.savetemplatePopup = true
          this.responeSave = response.data.msg
        } else {
          let response = await axios.post(apiUrl + '/api/dashboard/save', {
            username: this.username,
            dashboardName: this.user_index[this.tabIndex],
            slices: this.slices
          })
          window.analytics.track(`[Setting][SaveDashboard][Save]`, {
            value: {
              username: this.username,
              dashboardName: this.user_index[this.tabIndex],
              slices: this.slices
            }
          }, {
            integrations: {
                Amplitude: {
                  'session_id': this.ampid
                }
              }
            })
          this.savetemplatePopup = true
          this.responeSave = response.data.msg
        }
      } else {
        let response = await axios.post(apiUrl + '/api/dashboard/save', {
          username: this.username,
          dashboardName: this.user_index[this.tabIndex],
          slices: this.slices
        })
        window.analytics.track(`[Setting][SaveDashboard][Save]`, {
          value: {
            username: this.username,
            dashboardName: this.user_index[this.tabIndex],
            slices: this.slices
          }
        }, {
          integrations: {
              Amplitude: {
                'session_id': this.ampid
              }
            }
          })
        this.savetemplatePopup = true
        this.responeSave = response.data.msg
      }
      this.getIndex()
      this.stagNewTemplate = false
      this.saveStatus = true
      if (this.stageTabIndex !== 0) {
        this.tabIndex = this.stageTabIndex
      }
      this.stageTabIndex = 0
      this.shownDialogDiscardChanges = false
    },
    // closeSave () {
    //   alert('1')
    //   if (this.stagNewTemplate) {
    //     alert('2')
    //     if (this.tabIndex !== this.user_index.length - 1) {
    //       alert('3')
    //       this.savetemplateMode = false
    //     } else {
    //       alert('4')
    //       alert('AAA'+this.tabIndex)
    //       this.tabIndex = this.user_index.length - 1
    //       this.savetemplateMode = false
    //     }
    //   }
    // },
    pushstores () {
      let k = this.field.split('.keyword')
      this.selectedStores.push(`${k[0]}: ${this.keys}`)
      if (this.field === '@timestamp.keyword') {
        this.keys = String(Date.parse(this.keys))
      }
      let ob = {
        match_phrase: {
          [this.field]: this.keys
        }
      }
      this.stores.push(ob)
      axios.post(apiUrl + '/api/dashboard/stage', {
        type: 'filter',
        action: 'Filter',
        username: this.username,
        index: this.user_index[this.tabIndex],
        data: this.stores
      })
    },
    removeFilter (item) {
      let cutter = this.selectedStores.indexOf(item)
      this.selectedStores.splice(this.selectedStores.indexOf(item), 1)
      this.selectedStores = [...this.selectedStores]
      this.stores.splice(cutter, 1)
      this.stores = [...this.stores]
      axios.post(apiUrl + '/api/dashboard/stage', {
        type: 'filter',
        action: 'Filter',
        username: this.username,
        index: this.user_index[this.tabIndex],
        data: this.stores
      })
    },
    removeFilterTime (item) {
      this.selectTimenew.splice(this.selectTimenew.indexOf(item), 1)
      this.selectTimenew = [...this.selectTimenew]
      this.startTime = 'now-15m'
      this.endTime = 'now'
      this.interval = '10s'
    },
    clickSearch () {
      window.analytics.track(`[Tab][Search]`, {}, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
    },
    textSearch (command) {
      window.analytics.track(`[Search][Value]`, {
        value: this.textTemp
      }, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
      if (command && typeof command !== 'object') {
        this.textTemp = command
      }
      if (this.textTemp === null) {
        this.text = ''
      } else {
        this.text = this.textTemp
      }
      axios.post(apiUrl + '/api/dashboard/stage', {
        type: 'search',
        action: 'Search',
        username: this.username,
        index: this.user_index[this.tabIndex],
        query_string: this.textTemp
      })
    },
    clickSaveQuery () {
      window.analytics.track(`[Search][Tab][Save]`, {}, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
    },
    callItBack () {
      this.text = ''
      this.textTemp = ''
      axios.post(apiUrl + '/api/dashboard/stage', {
        type: 'search',
        action: 'Search',
        username: this.username,
        index: this.user_index[this.tabIndex],
        query_string: this.textTemp
      })
    },
    toNotification (sport) {
      this.$emit('toNotification', sport.name, sport.email)
    },
    async backToDefault () {
      window.analytics.track(`[Setting][Default Dashboard]`, {
        value: this.user_index[this.tabIndex]
      }, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
      this.slices = []
      if (this.user_index[this.tabIndex]) {
        await axios
          .post(apiUrl + '/api/dashboard/backToDefault', {
            index: this.user_index[this.tabIndex],
            templateSelect: this.user_index[this.tabIndex]
          })
          .then((response) => {
            this.slices = response.data.slices
            this.selectedIndex = this.user_index[this.tabIndex]
            this.backToDefaultmode = false
            this.checkDashboard = false
          })
          .catch((e) => {
            console.log(e.response.data.errmsg)
            alert(e.response.data.errmsg)
          })
      }
      this.conBackToDefault = false
      this.stateEdit = true
      this.loadChart('load', 1)
      this.loadChart('load', 1)
      // if (this.$refs.formBackToDefault.validate()) {
      //   await axios
      //     .post(apiUrl + '/api/dashboard/backToDefault', {
      //       index: this.user_index[this.tabIndex],
      //       templateSelect: this.templateSelect
      //     })
      //     .then((response) => {
      //       this.slices = response.data.slices
      //       this.selectedIndex = this.user_index[this.tabIndex]
      //       this.backToDefaultmode = false
      //     })
      //     .catch((e) => {
      //       console.log(e.response.data.errmsg)
      //       alert(e.response.data.errmsg)
      //     })
      // }
      // this.loadChart('load', 1)
      // this.loadChart('load', 1)
    },
    async backToDefaultSelectTemplate () {
      window.analytics.track(`[Setting][Default Dashboard]`, {
        value: this.user_index[this.tabIndex]
      }, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
      if (this.$refs.formBackToDefault.validate()) {
        await axios
          .post(apiUrl + '/api/dashboard/backToDefault', {
            index: this.user_index[this.tabIndex],
            templateSelect: this.templateSelect
          })
          .then((response) => {
            this.slices = response.data.slices
            this.selectedIndex = this.user_index[this.tabIndex]
            this.backToDefaultmode = false
          })
          .catch((e) => {
            console.log(e.response.data.errmsg)
            alert(e.response.data.errmsg)
          })
      }
      this.stateEdit = true
      this.loadChart('load', 1)
      this.loadChart('load', 1)
    },
    async backToDefaultgetTemplate () {
      await axios
        .post(apiUrl + '/api/dashboard/getTemplateName', {
          source: 'backtodefault'
        })
        .then((response) => {
          this.templateList = response.data.list
        })
        .catch((e) => {
          console.log(e.response.data.errmsg)
          alert(e.response.data.errmsg)
        })
      this.backToDefaultmode = true
    },
    async getIndex () {
      if (
        this.username !== this.$route.params.username &&
        this.$route.params.username !== undefined
      ) {
        await axios
          .post(apiUrl + '/api/dashboard/getIndexpdpa', {
            instance: this.$route.params.user_inst
          })
          .then((response) => {
            this.user_index = response.data.index
            this.deviceItem = response.data.index
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        await axios
          .post(apiUrl + '/api/dashboard/getIndexpdpa', {
            username: this.username
          })
          .then((response) => {
            this.user_index = response.data.index
            this.deviceItem = response.data.index
          })
          .catch((err) => {
            console.log(err)
          })
      }
      // console.log(this.user_index)
    },
    async editSavedSearch (command) {
      this.editSavedSearchMode = 'Edit'
      this.editingCommand = command
      this.showDialogSavedQuery = false
      this.showDialogSaveQuery = true
    },
    async openSavedSearch () {
      this.editSavedSearchMode = 'Save'
      this.showDialogSavedQuery = false
      this.showDialogSaveQuery = true
    },
    async getSearcheg () {
      try {
        let response = await axios.post(apiUrl + '/api/query/searcheg', {
            instance: this.user_inst,
            index: this.user_index[this.tabIndex]
        })
        if (response.data.key !== undefined) {
          this.keySearchEg = 'Search here...  (e.g. ' + response.data.key + ':' + response.data.value + ')'
        } else {
          this.keySearchEg = 'Search here...  (e.g. facebook)'
        }
      } catch (error) {
        this.keySearchEg = 'Search here...  (e.g. facebook)'
      }
    },
    toSettingWhitelist () {
      window.analytics.track(`[SettingPDPA]`, {}, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
      this.$router.push({ name: 'whiteList', params: { isExpired: this.isExpired } })
    },
    clickExportDashboard () {
      window.analytics.track(`[Feature][ReportPDF]`, {}, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
    },
    clickEditMode () {
      window.analytics.track(`[Setting]`, {}, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
      this.stateEdit = false
    },
    clickCloseEditMode () {
      window.analytics.track(`[Setting][Close]`, {}, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
      // await this.getDashboardTemplate()
      if (this.stateEdit) {
        this.shownDialogDiscardChanges = true
      }
    },
    clickSaveDashboard () {
      window.analytics.track(`[Setting][SaveDashboard]`, {}, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
    },
    clickAddChart () {
      window.analytics.track(`[Setting][AddChart]`, {}, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
    },
    clickCloseAddChart () {
      window.analytics.track(`[Setting][AddChart][close]`, {}, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
    },
    actionToChart () {
      this.stateEdit = true
    },
    clickClearfilter () {
      window.analytics.track(`[Feature][ClearFilter]`, {}, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
    }
  },
  // beforeRouteLeave (to, from, next) {
  //   if (JSON.stringify(this.storesSlice) !== JSON.stringify(this.slices) && this.saveStatus === false) {
  //     const answer = window.confirm('Do you want to save dashboard before leave?')
  //     if (answer) {
  //       this.saveDashboard()
  //       next()
  //     } else {
  //       next()
  //     }
  //   } else if (this.showDialogAddChart !== false || this.showDialogEditChart !== false || this.setAlert !== false) {
  //     const answer = window.confirm('Do you want to leave without finishing?')
  //     if (answer) {
  //       next()
  //     } else {
  //       next(false)
  //     }
  //   } else {
  //     next()
  //   }
  // },
  watch: {
    tabIndex: {
      handler: async function (tabIndex) {
        this.getSearcheg()
        this.loadCount = 0
        if (this.stagNewTemplate) {
          if (tabIndex !== this.user_index.length - 1) {
            this.stageTabIndex = tabIndex
            this.tabIndex = this.user_index.length - 1
            this.savetemplateMode = true
          } else {
          }
        } else {
          this.getDashboardTemplate()
          await axios.post(apiUrl + '/api/dashboard/stage', {
            type: 'index',
            username: this.username,
            index: this.user_index[tabIndex]
          })
        }
        window.analytics.track(`[Device][Tab][iLog]`, {
          value: this.user_index[tabIndex]
        }, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        })
      }
    },
    alertInterval: {
      handler: function (alertInterval) {
        let i
        if (alertInterval === 'm') {
          this.intervalalert = []
          for (i = 1; i <= 59; i++) {
            const obj = {
              text: `${i} minute`,
              value: i
            }
            this.intervalalert.push(obj)
          }
        } else if (alertInterval === 'h') {
          this.intervalalert = []
          for (i = 1; i <= 23; i++) {
            const obj = {
              text: `${i} hours`,
              value: i
            }
            this.intervalalert.push(obj)
          }
        } else if (alertInterval === 'd') {
          this.intervalalert = []
          for (i = 1; i <= 31; i++) {
            const obj = {
              text: `${i} day`,
              value: i
            }
            this.intervalalert.push(obj)
          }
        } else if (alertInterval === 'M') {
          this.intervalalert = []
          for (i = 1; i <= 12; i++) {
            const obj = {
              text: `${i} month`,
              value: i
            }
            this.intervalalert.push(obj)
          }
        }
      }
    },
    eventTrigger: {
      handler: function (eventTrigger) {
        if (this.eventTrigger === 'count') {
          this.alertType = [
            {
              text: 'Greater than',
              value: 'Greater than'
            },
            {
              text: 'Equal to',
              value: 'Equal to'
            },
            {
              text: 'Less than',
              value: 'Less than'
            }
          ]
          this.fieldalet = ''
        } else {
          this.alertType = [
            {
              text: 'Greater than',
              value: 'Greater than'
            }
          ]
        }
      }
    },
    selectedIndex: async function () {
      this.eventType = [
        {
          text: 'Count',
          value: 'count'
        }
      ]
      let field = []
      let response = await axios.post(apiUrl + '/api/query/allfield', {
        index: this.selectedIndex,
        instance: this.user_inst
      })
      this.eventType = [
        {
          text: 'Count',
          value: 'count'
        }
      ]
      if (response) {
        for (let [value, element] of response.data.entries()) {
          field = element === 'geoip'
            ? response.data.splice(value, 1, 'geoip.country_name')
            : response.data
        }
        this.dashField = field
        for (let findbyte of this.dashField) {
          // eslint-disable-next-line
          findbyte === 'bytes_in'
            ? this.eventType.push({
                text: 'Download',
                value: 'download'
              })
            : findbyte === 'bytes_out'
              ? this.eventType.push({
                  text: 'Upload',
                  value: 'upload'
                })
            : this.eventType
        }
      }
    },
    editMode: {
      handler: function (editMode) {
        if (this.editMode === false) {
          this.class_css = 'css-editMode-Close'
        } else {
          this.class_css = 'css-editMode-Open'
        }
      }
    },
    textTemp: {
      handler: function () {
        if (this.textTemp === '') {
          this.textSearch()
        }
      }
    },
    selectTimenew: function () {
      window.analytics.track(`[DillDown]`, {
        value: {
            group: 'PDPA',
            timestamp: this.selectTimenew.toString()
          }
      }, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
    },
    selectedStores: function () {
      window.analytics.track(`[DillDown]`, {
        value: {
          group: 'PDPA',
          keyword: this.selectedStores.toString()
        }
      }, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
    }
  }
}
</script>

<style scoped>
#icon {
    font-size: 100px;
}
.chart-item {
  z-index: 5;
  display: block;
  padding: 15px;
  box-sizing: border-box;
  background-color: #1d2126;
  min-height: 200px;
}

.position {
  position: sticky;
}

.chart-item-preview {
  z-index: 5;
  display: block;
  padding: 15px;
  box-sizing: border-box;
  background-color: #424242;
  min-height: 200px;
}

.css-editMode-Close {
  position: fixed;
  right: 0;
  width: 55px;
  background:rgba(170, 170, 170, 0.5);
  z-index: 1;
  border-radius: 8px 0 0 8px;
  text-align: center;
  top: 287px;
  box-shadow: 0 0 black;
}

.css-editMode-Open {
  position: fixed;
  right: 0;
  width: 55px;
  background: rgba(255, 0, 0, 0.5);
  z-index: 1;
  border-radius: 8px 0 0 8px;
  text-align: center;
  top: 230px;
  box-shadow: 0 0 black;
}
.css-Select-Dashboard-Template {
  width: 250px;
  max-height: 500px;
  position: fixed;
  right: 55px;
  top: 225px;
}
.radio-Box {
  max-height: 244px;
  overflow: auto;
}
.DialogEditAddChart {
  max-height: 1000px;
  overflow: auto;
}
.DialogFullChart {
  max-height: 1000px;
  overflow: auto;
}
.container {
  color: #fff;
  padding-bottom: 80px;
}
.isLoading {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
  cursor: pointer;
}
#isLoading_text {
  position: absolute;
  top: 50%;
  left: 50%;
  font-family: 'Droid serif';
  font-size: 44px;
  font-weight: 400;
  font-style: italic;
  line-height: 44px;
  margin: 0 0 12px;
  text-align: center;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}
.beta {
  color: #d86622;
  position: absolute;
  top: -10px;
  left: 30px;
  font-size: 0.75rem;
  font-weight: bold;
}
.category-box {
  text-transform: none;
  font-size: 16px;
  right: -5px;
  height: 48px;
  top: -18px;
}
.save-box {
  text-transform: none;
  font-size: 16px;
  height: 48px;
  margin: 0 auto;
  right: -3px;
  top: -12px;
}
.new {
  color: #f7184d;
  position: absolute;
  top: -15px;
  left: 55px;
  font-size: 0.8rem;
  font-weight: bold;
}
.license-card {
  border-radius: 30px;
  width: 900px;
  margin: 30px auto;
  background-color: #EEEEEE;
}
.license-expired {
  font-size: 22px;
  color: #424242;
  text-transform: none;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboardPDPA.vue